export function retrieveEthereumAddress(address: string, left: number = 4, right: number = 4) {
  return address && address.substring(0, 2 + left) + "..." + address.substring(address.length - right);
}
